export const CONSTANTS = {
	API_URL: process.env.VUE_APP_API_URL as string,
	RECAPTCHA_SITE_KEY: process.env.VUE_APP_RECAPTCHA_KEY as string,
	MAP_ACCESS_TOKEN: process.env.VUE_APP_MAP_TOKEN as string,
	SYSTEM_VERSION: 'v0.2.4',
	X_API_KEY: process.env.VUE_APP_X_API_KEY,
};
